import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { faBellExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { spacing } from 'syf-component-library/defaultTheme';
import { Inline } from 'syf-component-library/ui/spacing';
const MessageBoxWrapper = styled.div `
  background-color: #fafafa;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing.xlarge}px;
  padding: ${spacing.base}px;

  svg {
    font-size: 20px;
    padding: ${spacing.xsmall}px;
  }
`;
const SettlementDisclosure = () => {
    return (_jsxs(MessageBoxWrapper, Object.assign({ "data-cy": "settlement-disclosure", "data-testid": "settlement-disclosure-container" }, { children: [_jsx(FontAwesomeIcon, { "data-testid": "settlement-icon-svg", icon: faBellExclamation, size: "lg" }), _jsx(Inline, { size: "xsmall" }), _jsx("div", { children: _jsx(Trans, { components: [_jsx("strong", {})], i18nKey: "text.settlementReviewDisclosure" }) })] })));
};
export default SettlementDisclosure;
